module.exports = __webpack_public_path__ + "img/gold_frame.cdefd281.png";